import { axiosInstance } from "../axios/axiosConfig";

const controller = "notices";

export const getNoticeById = async (id) => {
  try {
    const response = await axiosInstance.get(`/${controller}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLinkToEmail = async (userId) => {
  try {
    const response = await axiosInstance.get(`/${controller}/GetLinkToEmail`, {
      params: { userId },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateLinkToEmail = async (userId, linkToEmail) => {
  try {
    await axiosInstance.post(`/${controller}/UpdateLinkToEmail`, null, {
      params: { userId, linkToEmail },
    });
  } catch (error) {
    throw error;
  }
};
const notificationController = "Notifications";

export const getNotificationList = async (body) => {
try {
  const response = await axiosInstance.post(`/${notificationController}/list`, body);
  return response.data;
  } catch (error) {
    throw error;
  }
}